import { CONTANTS } from '~/constants';
import { onLoad } from '~/helpers/onLoad';

function getAccessToken(idToken) {
  // Exchange ID token for access token
  const client = google.accounts.oauth2.initTokenClient({
    client_id: CONTANTS.GG_CLIENT_ID,
    scope: 'https://www.googleapis.com/auth/userinfo.profile', // Add any necessary scope
    callback: (tokenResponse) => {
      const accessToken = tokenResponse.access_token;
      console.log('Access Token:', accessToken);

      // Now you can use the access token to call Google APIs
      fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('User Info:', data);
        })
        .catch((error) => console.error('Error fetching user info:', error));
    },
  });

  // Initiating the token client to retrieve access token
  client.requestAccessToken();
}

export default ({ $axios, store, route }) => {
  onLoad(() => {
    // console.log('do something after onLoad');

    // Load google identity scripts
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s);
      js.id = id;
      js.defer = true;
      js.src = 'https://accounts.google.com/gsi/client';
      js.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', CONTANTS.GTAG);
        // TODO: Implement Google One Tab Sign In, return ID Token, not work with oauth2
        // Just show this popup in case user has not login
        // console.log('Google Identity scripts loaded', store.getters['auth/isSigned'], store);

        // TODO: Temporarily disable google one tab sign in unstill supports google sign in api ID token
        // if (!store.getters['auth/isSigned']) {
        //   window.google.accounts.id.initialize({
        //     client_id: CONTANTS.GG_CLIENT_ID,
        //     callback: window.verify,
        //     // auto_select: false,
        //     // cancel_on_tap_outside: false,
        //     // use_fedcm_for_prompt: false,
        //     // context: 'signin',
        //     auto_prompt: false // Set to false when you're manually calling google.accounts.id.prompt()
        //   });
        //   window.google.accounts.id.prompt((notification) => {
        //     // Fix issue caching in case popup google one tap not shown
        //     if (
        //       notification.isNotDisplayed() ||
        //       notification.isSkippedMoment()
        //     ) {
        //       document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
        //       google.accounts.id.prompt();
        //     }
        //   });
        // }
      };
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'google-identity');

    (window.verify = async function (response) {
      const { client_id, credential } = response;

      // const { data: tokenData } = await $axios.request({
      //   url: '/auth/verify/gtab/',
      //   params: {
      //     client_id,
      //     credential,
      //   },
      // });

      // const { access_token } = tokenData;
      const access_token = credential;

      getAccessToken(access_token);

      if (access_token) {
        // equivalent to call fetchApi in GoogleLogin.vue
        const { data } = await $axios.request({
          url: '/rest-auth/google/',
          method: 'post',
          data: {
            access_token,
          },
        });

        if (data) {
          const {
            user,
            access_token,
            refresh_token,
            access_token_expiration,
            refresh_token_expiration,
          } = data;

          const payload = {
            access_token,
            refresh_token,
            access_token_expiration,
            refresh_token_expiration,
            type: 'google',
          };

          store.dispatch('auth/oauth', { user, payload });
          route.push('/invoice');
        }
      }
    }),

    // Load Google Analytics 4 (GA4) scripts
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s);
      js.id = id;
      js.defer = true;
      js.src = `https://www.googletagmanager.com/gtag/js?id=${CONTANTS.GTAG}`;
      js.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('js', new Date());

        gtag('config', CONTANTS.GTAG);
      };
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'google-analytic-4');

    // Load FB sdk
    // window.fbAsyncInit = function () {
    //   if (!FB) return;

    //   FB.init({
    //     appId: CONTANTS.FB_APP_ID,
    //     autoLogAppEvents: true,
    //     xfbml: true,
    //     version: 'v13.0',
    //   });

    //   if (typeof facebookInit == 'function') {
    //     facebookInit();
    //   }
    // };

    // (function (d, s, id) {
    //   const fjs = d.getElementsByTagName(s)[0];
    //   if (d.getElementById(id)) {
    //     return;
    //   }
    //   const js = d.createElement(s);
    //   js.id = id;
    //   js.defer = true;
    //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
    //   // js.onload = () => {
    //   // };
    //   fjs.parentNode.insertBefore(js, fjs);
    // })(document, 'script', 'facebook-jssdk');

    // function facebookInit() {
    //   FB.XFBML.parse();
    // }
  });
};
